var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6557 6.70766C24.6659 6.96998 24.6693 7.23221 24.6693 7.49453C24.6693 15.4478 19.0745 24.6294 8.84365 24.6294C5.7009 24.6294 2.7786 23.6278 0.316406 21.9227C0.751643 21.9704 1.19367 22.0062 1.64247 22.0062C4.24823 22.0062 6.64825 21.0402 8.55199 19.4185C6.11805 19.3828 4.06284 17.6299 3.35403 15.2451C3.69431 15.3167 4.04473 15.3525 4.4031 15.3525C4.90842 15.3525 5.39905 15.2811 5.86933 15.138C3.32235 14.5895 1.40394 12.1571 1.40394 9.23568C1.40394 9.19991 1.40394 9.18792 1.40394 9.16407C2.15458 9.60525 3.01373 9.87937 3.92603 9.91514C2.43153 8.83006 1.44913 6.98188 1.44913 4.89519C1.44913 3.79818 1.72271 2.76074 2.2043 1.86645C4.94685 5.51519 9.04715 7.91194 13.6697 8.16235C13.5747 7.72116 13.5261 7.25624 13.5261 6.7912C13.5261 3.46441 16.0166 0.769531 19.0892 0.769531C20.6888 0.769531 22.1336 1.497 23.1476 2.66555C24.4172 2.40322 25.6065 1.90245 26.6827 1.21086C26.2655 2.61789 25.3849 3.79812 24.234 4.53741C25.36 4.39432 26.434 4.07262 27.4299 3.59566C26.6827 4.79998 25.7421 5.86105 24.6557 6.70766Z",
    fill: "#1EA1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlue);
export default __webpack_public_path__ + "static/media/twitter-blue.3c9cf9c01b122322817d3710fffeb9ef.svg";
export { ForwardRef as ReactComponent };